"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Signup entry point - redirects to the digital wallet creation page.
 * The digital-wallet page serves as the main signup flow entry point.
 */
export default function SignUpPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/auth/signup/digital-wallet");
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
